/**
 * Currencies that do not use decimal places (smallest unit is 1).
 * Used for formatting and price display so amounts are not divided by 100.
 */
export const ZERO_DECIMAL_CURRENCIES: string[] = ['JPY', 'KRW'];

/**
 * Currencies whose symbol is displayed after the amount (e.g. "10 €").
 */
export const CURRENCY_SYMBOLS_AFTER_AMOUNT = new Set(['EUR']);
